"use client";

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getAttributes } from "store/attribute/attribute.actions";
import { fetchAllBrand } from "store/brand/brand.actions";
import { fetchAllCategory } from "store/category/category.actions";

import { getAllColor } from "store/color/color.actions";
import { fetchAllBlog } from "store/blog/blog.actions";
import { fetchAllTickets } from "store/tickets/ticket.actions";
import { fetchAllActivities } from "store/activity/activity.actions";
import { fetchGalleryData } from "store/gallery/gallery.actions";
import { fetchOrdersStart } from "store/order/order.actions";
import { fetchSiteData } from "store/data/data.actions";

type DispatcherProps = {
  client?: string;
};

function Dispatcher({ client = "" }: DispatcherProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("Dispatcher running for:", client);
    const runDispatcher = (client: string) => {
      switch (client) {
        case "categories":
          dispatch(fetchAllCategory());
          dispatch(fetchGalleryData());
          break;
        case "brands":
          dispatch(fetchAllBrand());
          dispatch(fetchGalleryData());
          break;
        case "attributes":
          dispatch(getAttributes());
          break;
        case "colors":
          dispatch(getAllColor());
          break;
        case "blog":
          dispatch(fetchAllBlog());
          dispatch(fetchGalleryData());
          break;
        case "support":
          dispatch(fetchAllTickets());
          break;
        case "orders":
          dispatch(fetchOrdersStart());
          break;
        case "products":
          dispatch(fetchAllCategory());
          dispatch(fetchGalleryData());
          dispatch(getAttributes());
          dispatch(getAllColor());
          break;
        case "add-product":
          dispatch(fetchAllCategory());
          dispatch(getAllColor());
          dispatch(fetchGalleryData());
          dispatch(getAttributes());
          break;
        case "edit-products":
          dispatch(fetchAllCategory());
          dispatch(getAllColor());
          dispatch(fetchGalleryData());
          dispatch(getAttributes());
          break;
        case "all":
          dispatch(fetchAllCategory());
          dispatch(fetchAllBrand());
          dispatch(getAttributes());
          dispatch(getAllColor());
          break;

        default:
          break;
      }
    };

    dispatch(fetchAllActivities());
    dispatch(fetchSiteData());
    runDispatcher(client);
  }, [client, dispatch]);

  return null;
}

export default Dispatcher;
